import { useState } from 'react';
import { faqData } from '../../../mocks/faq';

export default function FaqCalculator() {
  const [bonusAmount, setBonusAmount] = useState(10000);
  const [wager, setWager] = useState(40);
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const totalWager = bonusAmount * wager;
  const estimatedTime = Math.ceil(totalWager / 50000);

  return (
    <section id="calculator" className="py-20 px-4 sm:px-6 lg:px-8 animate-on-scroll opacity-0">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 mb-16">
          <div>
            <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6">
              Калькулятор отыгрыша вейджера
            </h2>
            <p className="text-lg text-gray-600 mb-8">
              Рассчитайте, сколько нужно поставить для отыгрыша бонуса и сколько времени это займет
            </p>

            <div className="bg-white rounded-2xl shadow-2xl p-8 border border-gray-100">
              <div className="mb-6">
                <label className="block text-sm font-semibold text-gray-700 mb-3">
                  Сумма бонуса: {bonusAmount.toLocaleString('ru-RU')} ₽
                </label>
                <input
                  type="range"
                  min="1000"
                  max="250000"
                  step="1000"
                  value={bonusAmount}
                  onChange={(e) => setBonusAmount(Number(e.target.value))}
                  className="w-full h-3 bg-orange-200 rounded-full appearance-none cursor-pointer"
                  style={{
                    background: `linear-gradient(to right, #f97316 0%, #f97316 ${((bonusAmount - 1000) / 249000) * 100}%, #fed7aa ${((bonusAmount - 1000) / 249000) * 100}%, #fed7aa 100%)`
                  }}
                />
                <div className="flex justify-between text-xs text-gray-500 mt-2">
                  <span>1 000 ₽</span>
                  <span>250 000 ₽</span>
                </div>
              </div>

              <div className="mb-8">
                <label className="block text-sm font-semibold text-gray-700 mb-3">
                  Вейджер: x{wager}
                </label>
                <input
                  type="range"
                  min="20"
                  max="50"
                  step="5"
                  value={wager}
                  onChange={(e) => setWager(Number(e.target.value))}
                  className="w-full h-3 bg-orange-200 rounded-full appearance-none cursor-pointer"
                  style={{
                    background: `linear-gradient(to right, #f97316 0%, #f97316 ${((wager - 20) / 30) * 100}%, #fed7aa ${((wager - 20) / 30) * 100}%, #fed7aa 100%)`
                  }}
                />
                <div className="flex justify-between text-xs text-gray-500 mt-2">
                  <span>x20</span>
                  <span>x50</span>
                </div>
              </div>

              <div className="space-y-4 pt-6 border-t border-gray-200">
                <div className="flex items-center justify-between">
                  <span className="text-gray-700">Нужно поставить:</span>
                  <span className="text-2xl font-bold text-orange-600">
                    {totalWager.toLocaleString('ru-RU')} ₽
                  </span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-gray-700">Примерное время:</span>
                  <span className="text-xl font-bold text-gray-900">
                    {estimatedTime} {estimatedTime === 1 ? 'день' : estimatedTime < 5 ? 'дня' : 'дней'}
                  </span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-gray-700">Средняя ставка:</span>
                  <span className="text-lg font-semibold text-gray-900">50-100 ₽</span>
                </div>
              </div>

              <div className="mt-6 p-4 bg-orange-50 rounded-xl">
                <p className="text-sm text-gray-700">
                  <strong>Совет:</strong> При средней ставке 75 ₽ и RTP 96% вы потратите около {Math.round(totalWager * 0.04).toLocaleString('ru-RU')} ₽ на отыгрыш этого бонуса.
                </p>
              </div>
            </div>
          </div>

          <div>
            <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6">
              FAQ по бонусам казино онлайн
            </h2>
            <p className="text-lg text-gray-600 mb-8">
              Ответы на самые популярные вопросы об отыгрыше и выводе бонусов
            </p>

            <div className="space-y-4">
              {faqData.map((item, index) => (
                <div
                  key={index}
                  className="bg-white rounded-xl shadow-lg border border-gray-100 overflow-hidden hover:shadow-xl transition-all duration-300"
                >
                  <button
                    onClick={() => setOpenIndex(openIndex === index ? null : index)}
                    className="w-full px-6 py-5 text-left flex items-center justify-between hover:bg-gray-50 transition-colors duration-200 cursor-pointer"
                  >
                    <span className="font-semibold text-gray-900 pr-4">{item.question}</span>
                    <i
                      className={`ri-arrow-down-s-line text-2xl text-orange-500 transition-transform duration-300 flex-shrink-0 ${
                        openIndex === index ? 'rotate-180' : ''
                      }`}
                    ></i>
                  </button>
                  <div
                    className={`overflow-hidden transition-all duration-300 ${
                      openIndex === index ? 'max-h-96' : 'max-h-0'
                    }`}
                  >
                    <div className="px-6 pb-5 text-gray-600 leading-relaxed">
                      {item.answer}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-r from-orange-500 to-orange-600 rounded-2xl p-8 text-white mb-16">
          <h3 className="text-3xl font-bold mb-8 text-center">
            Стратегия "Бонусная охота": как зарабатывать на предложениях казино онлайн
          </h3>
          <div className="grid md:grid-cols-4 gap-6 mb-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-3xl font-bold">1</span>
              </div>
              <h4 className="font-bold mb-2">Выбор казино</h4>
              <p className="text-sm text-white/90">Ищите бонусы с вейджером x30-x35 и высоким RTP</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-3xl font-bold">2</span>
              </div>
              <h4 className="font-bold mb-2">Выбор игр</h4>
              <p className="text-sm text-white/90">Играйте в слоты с RTP 96%+ и средней волатильностью</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-3xl font-bold">3</span>
              </div>
              <h4 className="font-bold mb-2">Управление банкроллом</h4>
              <p className="text-sm text-white/90">Ставка не более 1-2% от бонусной суммы</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-3xl font-bold">4</span>
              </div>
              <h4 className="font-bold mb-2">Вывод средств</h4>
              <p className="text-sm text-white/90">Сразу после отыгрыша выводите выигрыш</p>
            </div>
          </div>

          <div className="bg-white/10 rounded-xl p-6 backdrop-blur-sm">
            <h4 className="text-xl font-bold mb-4">Детальный план действий для бонусной охоты:</h4>
            <div className="space-y-4 text-sm">
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 bg-white/20 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-search-line text-lg"></i>
                </div>
                <div>
                  <strong className="block mb-1">Исследование предложений:</strong>
                  <p className="text-white/90">Составьте список из 10-15 казино онлайн с лучшими условиями. Обращайте внимание не только на размер бонуса, но и на вейджер, максимальную ставку при отыгрыше, список разрешенных игр и лимиты на вывод.</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 bg-white/20 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-calculator-line text-lg"></i>
                </div>
                <div>
                  <strong className="block mb-1">Расчет математического ожидания:</strong>
                  <p className="text-white/90">Используйте формулу: (Сумма бонуса × RTP слота) - (Сумма вейджера × House Edge). Например, бонус 10 000 ₽ с вейджером x30 в слоте с RTP 96% даст ожидаемый результат: (10 000 × 0.96) - (300 000 × 0.04) = -2 400 ₽. Ищите предложения с минимальными потерями.</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 bg-white/20 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-gamepad-line text-lg"></i>
                </div>
                <div>
                  <strong className="block mb-1">Выбор оптимальных слотов:</strong>
                  <p className="text-white/90">Лучшие слоты для отыгрыша: Book of Dead (RTP 96.21%), Starburst (96.09%), Gonzo's Quest (95.97%). Избегайте прогрессивных джекпотов и слотов с высокой волатильностью — они съедают банкролл быстрее.</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 bg-white/20 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-line-chart-line text-lg"></i>
                </div>
                <div>
                  <strong className="block mb-1">Стратегия ставок:</strong>
                  <p className="text-white/90">Делайте ставки 0.5-1% от текущего баланса. Если бонус 10 000 ₽, начинайте со ставок 50-100 ₽. При росте баланса увеличивайте ставку пропорционально, при падении — уменьшайте. Это защитит от быстрого слива.</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 bg-white/20 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-time-line text-lg"></i>
                </div>
                <div>
                  <strong className="block mb-1">Тайм-менеджмент:</strong>
                  <p className="text-white/90">Разбейте отыгрыш на сессии по 1-2 часа. Делайте перерывы каждые 30 минут. Усталость приводит к ошибкам и превышению лимитов ставок. Оптимально отыгрывать 20-30% вейджера за сессию.</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 bg-white/20 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-shield-check-line text-lg"></i>
                </div>
                <div>
                  <strong className="block mb-1">Контроль условий:</strong>
                  <p className="text-white/90">Ведите таблицу: казино, сумма бонуса, вейджер, прогресс отыгрыша, текущий баланс. Проверяйте прогресс в личном кабинете каждые 50-100 ставок. Некоторые казино онлайн не засчитывают ставки выше лимита.</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-16">
          <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-2xl p-8 border border-green-200">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-green-500 rounded-xl flex items-center justify-center">
                <i className="ri-lightbulb-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900">Продвинутые техники отыгрыша</h3>
            </div>
            <div className="space-y-4">
              <div>
                <h4 className="font-bold text-gray-900 mb-2 flex items-center gap-2">
                  <i className="ri-arrow-right-s-fill text-green-500"></i>
                  Метод "Двойной игры"
                </h4>
                <p className="text-gray-700 text-sm leading-relaxed">
                  Открывайте два слота одновременно и чередуйте ставки. Это помогает избежать эмоциональных решений и позволяет переключаться при серии проигрышей. Особенно эффективно с автоспином на минимальной скорости.
                </p>
              </div>
              <div>
                <h4 className="font-bold text-gray-900 mb-2 flex items-center gap-2">
                  <i className="ri-arrow-right-s-fill text-green-500"></i>
                  Техника "Лестница"
                </h4>
                <p className="text-gray-700 text-sm leading-relaxed">
                  Начинайте с минимальных ставок (50 ₽), после каждых 100 успешных спинов увеличивайте на 10-20 ₽. При достижении 50% вейджера зафиксируйте ставку. Последние 20% отыгрывайте на минимуме — это снижает риск слива перед финишем.
                </p>
              </div>
              <div>
                <h4 className="font-bold text-gray-900 mb-2 flex items-center gap-2">
                  <i className="ri-arrow-right-s-fill text-green-500"></i>
                  Стратегия "Безопасная зона"
                </h4>
                <p className="text-gray-700 text-sm leading-relaxed">
                  Установите стоп-лосс на уровне 70% от начального бонуса. Если баланс упал до 7 000 ₽ при стартовых 10 000 ₽ — остановитесь на 24 часа. Статистика показывает, что 80% игроков, продолжающих после такого падения, сливают весь бонус.
                </p>
              </div>
              <div>
                <h4 className="font-bold text-gray-900 mb-2 flex items-center gap-2">
                  <i className="ri-arrow-right-s-fill text-green-500"></i>
                  Метод "Ротация провайдеров"
                </h4>
                <p className="text-gray-700 text-sm leading-relaxed">
                  Меняйте провайдеров каждые 25% вейджера: начните с Pragmatic Play, затем NetEnt, потом Play'n GO, финишируйте на Microgaming. Разные RNG-алгоритмы снижают вероятность попадания в "холодную" полосу одного провайдера.
                </p>
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-br from-red-50 to-orange-50 rounded-2xl p-8 border border-red-200">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-red-500 rounded-xl flex items-center justify-center">
                <i className="ri-alert-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900">Критические ошибки при отыгрыше</h3>
            </div>
            <div className="space-y-4">
              <div>
                <h4 className="font-bold text-gray-900 mb-2 flex items-center gap-2">
                  <i className="ri-close-circle-fill text-red-500"></i>
                  Превышение максимальной ставки
                </h4>
                <p className="text-gray-700 text-sm leading-relaxed">
                  Даже одна ставка выше лимита (обычно 50-100 ₽) аннулирует весь бонус и выигрыши. Казино онлайн отслеживают это автоматически. Всегда проверяйте условия перед началом и установите напоминание о лимите.
                </p>
              </div>
              <div>
                <h4 className="font-bold text-gray-900 mb-2 flex items-center gap-2">
                  <i className="ri-close-circle-fill text-red-500"></i>
                  Игра в запрещенные слоты
                </h4>
                <p className="text-gray-700 text-sm leading-relaxed">
                  Многие казино исключают из отыгрыша слоты с покупкой бонусных раундов (Book of Dead, Wanted Dead or Alive). Ставки в них не засчитываются в вейджер, но списываются с баланса. Проверяйте список разрешенных игр.
                </p>
              </div>
              <div>
                <h4 className="font-bold text-gray-900 mb-2 flex items-center gap-2">
                  <i className="ri-close-circle-fill text-red-500"></i>
                  Попытка вывода до завершения
                </h4>
                <p className="text-gray-700 text-sm leading-relaxed">
                  Запрос на вывод при незавершенном вейджере автоматически аннулирует бонус и все выигрыши. Даже если вы передумаете и отмените запрос — бонус уже сгорел. Дождитесь 100% выполнения условий.
                </p>
              </div>
              <div>
                <h4 className="font-bold text-gray-900 mb-2 flex items-center gap-2">
                  <i className="ri-close-circle-fill text-red-500"></i>
                  Игнорирование срока действия
                </h4>
                <p className="text-gray-700 text-sm leading-relaxed">
                  Большинство бонусов действуют 7-30 дней. Не успели отыграть — бонус сгорает вместе с выигрышами. Рассчитывайте время заранее: при вейджере x40 и бонусе 10 000 ₽ нужно минимум 3-5 дней активной игры.
                </p>
              </div>
              <div>
                <h4 className="font-bold text-gray-900 mb-2 flex items-center gap-2">
                  <i className="ri-close-circle-fill text-red-500"></i>
                  Эмоциональная игра после проигрышей
                </h4>
                <p className="text-gray-700 text-sm leading-relaxed">
                  Попытка "отыграться" увеличением ставок — главная причина слива бонусов. После серии из 10-15 проигрышных спинов сделайте перерыв на 30 минут. Вернитесь с холодной головой и продолжите по плану.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-r from-indigo-500 to-purple-600 rounded-2xl p-8 text-white">
          <h3 className="text-3xl font-bold mb-6 text-center">
            Математика бонусов: как казино онлайн зарабатывают на вейджере
          </h3>
          <div className="grid md:grid-cols-3 gap-6 mb-6">
            <div className="bg-white/10 rounded-xl p-6 backdrop-blur-sm">
              <div className="text-4xl font-bold mb-2">96%</div>
              <div className="text-sm text-white/90 mb-3">Средний RTP слотов</div>
              <p className="text-xs text-white/80">
                Казино возвращает игрокам 96% от ставок, оставляя себе 4%. При вейджере x40 и бонусе 10 000 ₽ вы поставите 400 000 ₽, из которых казино заработает 16 000 ₽.
              </p>
            </div>
            <div className="bg-white/10 rounded-xl p-6 backdrop-blur-sm">
              <div className="text-4xl font-bold mb-2">23%</div>
              <div className="text-sm text-white/90 mb-3">Процент успешных отыгрышей</div>
              <p className="text-xs text-white/80">
                Только каждый четвертый игрок полностью отыгрывает бонус и выводит средства. 77% сливают бонус до завершения вейджера из-за ошибок или невезения.
              </p>
            </div>
            <div className="bg-white/10 rounded-xl p-6 backdrop-blur-sm">
              <div className="text-4xl font-bold mb-2">x35</div>
              <div className="text-sm text-white/90 mb-3">Оптимальный вейджер</div>
              <p className="text-xs text-white/80">
                Бонусы с вейджером x30-x35 дают лучший баланс между размером и реальностью отыгрыша. Ниже x30 — маленькие суммы, выше x40 — слишком сложно завершить.
              </p>
            </div>
          </div>
          <div className="bg-white/10 rounded-xl p-6 backdrop-blur-sm">
            <h4 className="text-xl font-bold mb-4">Пример расчета реальной ценности бонуса:</h4>
            <div className="space-y-3 text-sm">
              <div className="flex items-center justify-between border-b border-white/20 pb-2">
                <span>Бонус казино онлайн:</span>
                <strong>10 000 ₽</strong>
              </div>
              <div className="flex items-center justify-between border-b border-white/20 pb-2">
                <span>Вейджер:</span>
                <strong>x40</strong>
              </div>
              <div className="flex items-center justify-between border-b border-white/20 pb-2">
                <span>Нужно поставить:</span>
                <strong>400 000 ₽</strong>
              </div>
              <div className="flex items-center justify-between border-b border-white/20 pb-2">
                <span>House Edge (4%):</span>
                <strong className="text-red-300">-16 000 ₽</strong>
              </div>
              <div className="flex items-center justify-between border-b border-white/20 pb-2">
                <span>Вероятность успеха (23%):</span>
                <strong>×0.23</strong>
              </div>
              <div className="flex items-center justify-between pt-2">
                <span className="text-lg">Реальная ценность бонуса:</span>
                <strong className="text-2xl text-yellow-300">-1 380 ₽</strong>
              </div>
            </div>
            <p className="text-xs text-white/80 mt-4 text-center">
              Математически, этот бонус невыгоден. Но с правильной стратегией и удачей вы можете попасть в те 23% успешных игроков и вывести прибыль.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}